import styled from 'styled-components';

export const StackItem = styled.rect`
  transition: opacity 0.3s ease-in;
  opacity: ${({ isHoverActive, isGroupHovered }) => (isHoverActive && !isGroupHovered ? 0.3 : 1)};
`;
